import React from 'react';
// 公共组件
import { Row, Col } from './../CtGrid';

// 业务组件
import CtMedia from '../CtMedia';
import './css/index.scss';

export default function MdCaseCard(props) {
  const { data } = props;
  return (
    <div className="material-mdCaseCard">
      <Row gutter={[24, 24]}>
        {data.map((item, index) => (
          <Col colSpan={6} phone={24} key={`col-${index}`}>
            <CtMedia
              data={item}
              card
              shadow
              radius
              className={`bg-${index}`}
              component={item.href ==='#' ? 'div' : 'a'}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
